<div *ngIf="sites.length > 1 && groups.length > 0 && !isLoading && !isDone" class="cas-info">
    <h4>Add these sites to selected groups</h4>
    <div class="selected-list">
        <acabim-data-display [dataMap]="sites" [noLabel]="true"></acabim-data-display>
    </div>
    <form [formGroup]="groupForm">
        <acabim-form-block labelWidth="10" [labelAlign]="'right'" [colonize]="true">
            <acabim-form-input-wrapper>
                <acabim-form-input-label>Site Groups</acabim-form-input-label>
                <acabim-form-input-content>
                    <p-multiSelect
                            [options]="groups"
                            optionValue="value"
                            optionLabel="label"
                            formControlName="selectedGroups"></p-multiSelect>
                </acabim-form-input-content>
            </acabim-form-input-wrapper>
        </acabim-form-block>

        <div class="cas-action-buttons cas-action-buttons-bottom">
            <button (click)="onSubmit()" class="cas-button-action cas-button-right">Add</button>
        </div>
    </form>
</div>

<ng-container *ngIf="isLoading">
    <acabim-loading-view></acabim-loading-view>
</ng-container>

<ng-container *ngIf="isDone">
    <div class="cas-info">
        <h4>Done!</h4>
        <div class="cas-action-buttons">
            <button (click)="onDone()">Close</button>
        </div>
    </div>
</ng-container>
